import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { translations, getTranslation } from '../translations';

export const useTranslations = () => {
  const language = useSelector((state) => state.app.language);
  
  const t = useCallback((key, params = {}) => {
    const currentTranslations = translations[language] || translations.en;
    const value = getTranslation(currentTranslations, key);
    if (typeof value !== 'string') {
      return value;
    }
    return value.replace(/\{(\w+)\}/g, (match, paramKey) => {
      if (params[paramKey] === undefined || params[paramKey] === null) {
        return match;
      }
      return String(params[paramKey]);
    });
  }, [language]);

  const getCurrentLanguage = () => language;
  
  const getAvailableLanguages = () => {
    return Object.keys(translations).map(lang => ({
      code: lang,
      name: lang === 'en' ? 'English' : lang === 'de' ? 'Deutsch' : lang,
    }));
  };

  return {
    t,
    language,
    getCurrentLanguage,
    getAvailableLanguages,
  };
}; 